import axios from 'axios'
import React, { useState, useEffect } from 'react'

const FetchData = () => {
    const [data, setData] = useState([])
    const [search, setSearch] = useState("")

    const [delData, setDelData] = useState([])
    const url = "https://dummyjson.com/products"

    const userData = async () => {
        return axios.get(url).then((res) => setData(res.data.products))

    }

    useEffect(() => {
        userData()
    }, [])

    const handleDelete = (id) => {
        const deletedItem = data[id];
        const updatedData = data.filter((_, index) => index !== id);
        setData(updatedData);
        setDelData([...delData, deletedItem]);
        console.log(deletedItem, "hghj")
    };

    const handleSearch = () => {
        const searchData = data.filter((item, id) => item.title.toLowerCase().includes(search.toLowerCase())
        )
        setData(searchData)

        setSearch("");
    }

    console.log(delData);


    return (
        <>
            <div className='w-full min-h-screen'>
                <div className='container mx-auto'>
                    <div className='mt-20 gap-5 flex flex-col md:flex-row items-center'>
                        <input name='name' value={search} onChange={(e) => setSearch(e.target.value)} type="text" className='border-2 rounded-md border-gray-300 mb-3 md:mb-0 md:mr-3' placeholder="Search" />
                        <button onClick={handleSearch} className='px-3 w-full md:w-20 py-1 text-white rounded-md cursor-pointer bg-blue-500 hover:bg-blue-600'>Search</button>
                    </div>
                    <div className='mt-10 md:mt-20 rounded-lg w-full p-5 mx-auto flex flex-wrap gap-5'>
                        {data.map((item, index) => (
                            <div key={index} className="w-full md:w-[30%] overflow-hidden shadow-lg mb-5">
                                <img className="w-full h-60" src={item.images[0]} alt="Placeholder" />
                                <div className="px-6 py-4">
                                    <p className="font-bold capitalize text-xl mb-2">{item.title}</p>
                                    <p className="text-gray-700 capitalize text-base">
                                        {item.description}
                                    </p>
                                </div>
                                <div className="px-6 py-4">
                                    <button onClick={() => handleDelete(index)} className="inline-block font-semibold hover:bg-red-600 cursor-pointer bg-red-500 text-white rounded-full px-3 py-1 text-sm font-semibold mr-2">Remove</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </>
    )
}

export default FetchData